export const tr = {
  // Header
  header: {
    title: 'VOLTRON',
    subtitle: 'AI Operasyon Kontrol Merkezi',
    connected: 'Baglanti Aktif',
    connecting: 'Baglaniliyor',
    reconnecting: 'Yeniden Baglaniliyor',
    disconnected: 'Baglanti Kesildi',
  },

  // Sidebar
  sidebar: {
    fileExplorer: 'Dosya Gezgini',
    protectionZones: 'Koruma Bolgeleri',
    patternTester: 'Desen Testi',
    fileHistory: 'Dosya Gecmisi',
  },

  // ActionFeed
  actionFeed: {
    title: 'Canli Aksiyon Akisi',
    scrollToLatest: 'Son olaya git',
    events: 'olay',
    noEventsTitle: 'Henuz olay yok',
    noEventsDescription: 'Yapay zeka aksiyonlari yakalandikca burada gercek zamanli olarak gorunecek.',
  },

  // ActionFilter
  actionFilter: {
    filterByFilePath: 'Dosya yoluna gore filtrele...',
  },

  // ExecutionControls
  executionControls: {
    title: 'Calistirma Kontrolu',
    processed: 'Islenen:',
    pending: 'Bekleyen:',
    autoStopThreshold: 'Otomatik durdurma esigi:',
    stopReason: 'Durdurma nedeni:',
    stop: 'DURDUR',
    continue: 'DEVAM',
    reset: 'SIFIRLA',
    confirm: 'Emin misiniz?',
    stateHistory: 'Durum Gecmisi',
  },

  // RiskGauge
  riskGauge: {
    title: 'Risk Seviyesi',
    highestRisk: 'En Yuksek Risk',
  },

  // RiskTimeline
  riskTimeline: {
    title: 'Risk Zaman Cigisi',
    waitingForData: 'Yeterli veri bekleniyor...',
    risk: 'Risk',
  },

  // StateHistory
  stateHistory: {
    title: 'Durum Gecmisi',
    noTransitions: 'Henuz gecis yok',
    total: 'toplam',
  },

  // ZoneManager
  zoneManager: {
    noZones: 'Koruma bolgesi tanimlanmamis.',
    addZone: 'Bolge ekle',
    pathPattern: 'Yol deseni (orn., /etc/nginx/**)',
    reasonOptional: 'Neden (istege bagli)',
    save: 'Kaydet',
    cancel: 'Iptal',
    zoneCreated: 'Bolge Olusturuldu',
    zoneCreatedMessage: 'Koruma bolgesi "{path}" olusturuldu.',
    createFailed: 'Olusturma Basarisiz',
    zoneDeleted: 'Bolge Silindi',
    zoneDeletedMessage: 'Koruma bolgesi kaldirildi.',
    deleteFailed: 'Silme Basarisiz',
    cannotDeleteSystem: 'Sistem bolgesi silinemez',
    deleteZone: 'Bolgeyi sil',
  },

  // FileHistory
  fileHistory: {
    operations: 'islem',
    notFound: 'Gecmis bulunamadi',
    failedToLoad: 'Gecmis yuklenemedi',
  },

  // ActivityChart
  activityChart: {
    title: 'Aktivite',
    waitingForData: 'Yeterli veri bekleniyor...',
  },

  // RiskBreakdown
  riskBreakdown: {
    title: 'Risk Dagilimi',
    waitingForData: 'Veri bekleniyor...',
    total: 'Toplam',
  },

  // ProjectStats
  projectStats: {
    title: 'Istatistikler',
    totalEvents: 'Toplam Olay',
    byRiskLevel: 'Risk Seviyesine Gore',
    byActionType: 'Aksiyon Turune Gore',
  },

  // PatternTester
  patternTester: {
    title: 'Desen Test Araci',
    globPattern: 'Glob Deseni',
    testPath: 'Test Yolu',
    fileTreeMatches: 'Dosya Agaci Eslesen:',
    more: 'daha...',
    recursiveMatch: '= tekrarli esleme',
    singleLevelMatch: '= tek seviye esleme',
    singleCharacter: '= tek karakter',
  },

  // App
  app: {
    loadingVoltron: 'Voltron yukleniyor...',
    connectionError: 'Baglanti Hatasi',
    retry: 'Yeniden Dene',
    project: 'Proje',
    select: 'Sec...',
    noProjects: 'Proje yok',
    failedToLoadProjects: 'Projeler yuklenemedi',
    actionFeed: 'Aksiyon Akisi',
    github: 'GitHub',
    selectProjectFirst: 'Lutfen once bir proje secin',
    snapshots: 'Snapshot\'lar',
    behavior: 'Davranis',
    prompts: 'Promptlar',
    smartSetup: 'Smart Setup',
  },

  // StatusBar (moved to end of file)

  // Notifications (used in useEventStream)
  notifications: {
    executionStopped: 'Calistirma Durduruldu',
    executionResumed: 'Calistirma Devam Etti',
    executionReset: 'Calistirma Sifirlandi',
    riskAlert: 'Risk Alarmi',
    stoppedMessage: 'AI operasyonu operator tarafindan durduruldu.',
    resumedMessage: 'AI operasyonu devam ettirildi.',
    resetMessage: 'Calistirma durumu IDLE olarak sifirlandi.',
    stopFailed: 'Durdurma Basarisiz',
    continueFailed: 'Devam Ettirme Basarisiz',
    resetFailed: 'Sifirlama Basarisiz',
    unknownError: 'Bilinmeyen hata',
  },

  // EmptyState / Common
  common: {
    noFiles: 'Dosya yok',
    filesWillAppear: 'Olaylar alindikca dosyalar gorunecek.',
    loading: 'Yukleniyor...',
    ok: 'Tamam',
    close: 'Kapat',
    errorTitle: 'Bir hata olustu',
    errorDescription: 'Bu bolumde beklenmeyen bir hata meydana geldi. Sayfayi yenileyerek tekrar deneyebilirsiniz.',
    retry: 'Yenile',
    technicalDetails: 'Teknik Detay',
  },

  // FileTree
  fileTree: {
    heatMap: 'Isi Haritasi',
  },

  // DiffViewer
  diffViewer: {
    diffTruncated: 'Diff kisildi - icerik tamamen gosterilmek icin cok buyuk',
    unified: 'Birlesik Gorunum',
    split: 'Yan Yana Gorunum',
    oldFile: 'Eski Dosya',
    newFile: 'Yeni Dosya',
  },

  // DiffHeader
  diffHeader: {
    created: 'Olusturuldu',
    modified: 'Degistirildi',
    deleted: 'Silindi',
    renamed: 'Yeniden Adlandirildi',
    dirCreated: 'Dizin Olusturuldu',
    dirDeleted: 'Dizin Silindi',
    dependency: 'Bagimlilik',
    config: 'Yapilandirma',
  },

  // GitHubReport
  github: {
    analyze: 'Analiz Et',
    analyzing: 'Analiz ediliyor...',
    dependencies: 'Bagimliliklar',
    devDependencies: 'Gelistirme Bagimliliklari',
    breakingChanges: 'Kirilici Degisiklikler',
    compliance: 'Uyumluluk',
    enterRepoUrl: 'GitHub repo URL girin ve analiz baslatin',
    noBreakingChanges: 'Kirilici degisiklik tespit edilmedi',
    breakingChange: 'kirilici degisiklik',
    noDependencyData: 'Bagimlilik verisi yok',
    noComplianceData: 'Uyumluluk verisi yok',
    complianceScore: 'Uyumluluk Puani',
    total: 'Toplam',
    outdated: 'Guncel Degil',
    conflicts: 'Catismalar',
    versionConflicts: 'Surum Catismalari',
    before: 'Once',
    after: 'Sonra',
    pass: 'basarili',
    fail: 'basarisiz',
    warn: 'uyari',
    searchAndAdapt: 'Claude ile Ara ve Adapte Et',
    searchPlaceholder: 'ornek: react login page tailwind',
    targetDir: 'Hedef dizin',
    anyFramework: 'Herhangi bir framework',
    searching: 'Araniyor...',
    searchAndAdaptBtn: 'Ara ve Adapte Et',
  },

  // Layout
  layout: {
    showSidebar: 'Kenar cubugunu goster',
    hideSidebar: 'Kenar cubugunu gizle',
    showPanel: 'Paneli goster',
    hidePanel: 'Paneli gizle',
  },

  // Operations
  operations: {
    fileCreate: 'Olustur',
    fileModify: 'Degistir',
    fileDelete: 'Sil',
    fileRename: 'Yeniden Adlandir',
    dirCreate: 'Dizin+',
    dirDelete: 'Dizin-',
    dependencyChange: 'Bagimlilik',
    configChange: 'Yapilandirma',
  },

  // Risk Levels
  riskLevels: {
    none: 'YOK',
    low: 'DUSUK',
    medium: 'ORTA',
    high: 'YUKSEK',
    critical: 'KRITIK',
  },

  // Snapshots
  snapshots: {
    title: 'Snapshot Tarayici',
    loadMore: 'Daha fazla yukle',
    noSnapshots: 'Henuz snapshot yok',
    label: 'Etiket',
    setLabel: 'Etiket ata',
    rollback: 'Geri Al',
    rollbackConfirm: 'Bu snapshot\'a geri donmek istediginizden emin misiniz?',
    rollbackSuccess: 'Geri alma basarili',
    rollbackMessage: 'Interceptor bu commit\'e geri donecek.',
    files: 'dosya',
    showFiles: 'Dosyalari goster',
    hideFiles: 'Dosyalari gizle',
    compare: 'Karsilastir',
    selectForCompare: 'Karsilastirmak icin sec',
    prune: 'Eski snapshot\'lari temizle',
    pruneConfirm: 'Son {keep} snapshot haricindeki tumunu silmek istediginizden emin misiniz?',
    pruneSuccess: 'Temizleme basarili',
    pruneMessage: '{deleted} snapshot silindi, {remaining} kaldi.',
    critical: 'Kritik',
    commit: 'Commit',
  },

  // Interceptor Status
  interceptor: {
    title: 'Agent Durumu',
    rate: 'Hiz',
    state: 'Durum',
  },

  // Behavior Scoring
  behavior: {
    title: 'Davranis Puani',
    calculate: 'Hesapla',
    overallScore: 'Genel Puan',
    riskScore: 'Risk Puani',
    velocityScore: 'Hiz Puani',
    complianceScore: 'Uyumluluk Puani',
    details: 'Detaylar',
    totalActions: 'Toplam Aksiyon',
    actionsPerMin: 'Aksiyon/dk',
    zoneViolations: 'Bolge Ihlalleri',
    trend: 'Trend',
    noData: 'Henuz davranis verisi yok',
    howItWorks: 'Nasil Calisir?',
    step1: 'Agent calisirken aksiyonlar otomatik loglanir',
    step2: 'Her 5 dakikada davranis puani hesaplanir',
    step3: 'Trend grafik ile gecmis performans takip edilir',
    dataWillAppear: 'Agent aktif oldugunda veriler otomatik olusacak',
  },

  // Prompt Versioning
  prompts: {
    title: 'Prompt Versiyonlari',
    newVersion: 'Yeni Versiyon',
    namePlaceholder: 'Versiyon adi...',
    contentPlaceholder: 'Prompt icerigi...',
    create: 'Olustur',
    cancel: 'Iptal',
    active: 'Aktif',
    activate: 'Aktif Et',
    compareParent: 'Onceki ile karsilastir',
    noVersions: 'Henuz prompt versiyonu yok',
    noChanges: 'Degisiklik yok',
  },

  // Agent Orchestration
  agent: {
    spawnAgent: 'Agent Baslat',
    prompt: 'Prompt',
    promptPlaceholder: 'Claude\'a ne yapmasini istiyorsunuz?',
    model: 'Model',
    targetDir: 'Hedef Dizin',
    spawn: 'Baslat',
    pause: 'Duraklat',
    resume: 'Devam',
    kill: 'Sonlandir',
    inject: 'Enjekte Et',
    tab: 'Agent',
    noLocation: 'Konum bekleniyor...',
    extractingPlan: 'Plan cikariliyor...',
    step: 'Adim',
    context: 'Baglam',
    injectPlaceholder: 'Agent\'a talimat enjekte et...',
    includeConstraints: 'Simulator kisitlamalarini dahil et',
    output: 'Cikti',
    search: 'Ara...',
    export: 'Disa Aktar',
    noOutput: 'Henuz cikti yok',
    scrollToBottom: 'Asagiya kay',
    bufferWarning: 'Cikti tamponu dolmak uzere ({{count}}/{{max}}). Eski kayitlar siliniyor.',
    gpsTracker: 'GPS Takip',
    plan: 'Plan',
    promptInjector: 'Prompt Enjeksiyonu',
    agentOutput: 'Agent Ciktisi',
    searchAndAdapt: 'Ara ve Adapte Et',
    searchQuery: 'Arama sorgusu...',
    framework: 'Framework',
    simulator: 'Simulator',
    refreshSimulator: 'Simulatoru Yenile',
    openSimulator: 'Yeni Sekmede Ac',
    simulatorIdle: 'Simulator onizlemesi icin bir agent baslatin',
    preview: 'Onizleme',
    previewMode: 'Onizleme',
    simulatorMode: 'Simulator',
    switchToSimulator: 'Simulator moduna gec',
    switchToPreview: 'Onizleme moduna gec',
    planExtractionFailed: 'Plan cikarilamadi',
    noPlanDetected: 'Bu oturumda plan algilanamadi',
    planFromBreadcrumbs: 'Dosya izlerinden olusturulan plan',
    agentCompleted: 'Agent tamamlandi',
    agentCrashed: 'Agent coktu',
    pauseFailed: 'Duraklatma basarisiz',
    resumeFailed: 'Devam ettirme basarisiz',
    killFailed: 'Durdurma basarisiz',
    sending: 'Gonderiliyor...',
    sendingEdits: 'Degisiklikler yapay zekaya iletiliyor...',
    editsSent: 'Duzenlemeler gonderildi',
    aiApplying: 'Yapay zeka degisiklikleri uyguluyor...',
    sendFailed: 'Gonderim basarisiz',
    couldNotSendEdits: 'Degisiklikler gonderilemedi',
    filesCreated: 'dosya olusturuldu',
    filesProcessed: '{count} dosya islendi',
    workOnFile: 'Bu dosyada calis: {path}',
    showFileList: 'Dosyalari goster',
    hideFileList: 'Dosyalari gizle',
    editorHint: 'Tikla: sec | Surukle: tasi | Cift tikla: metin | Sag tikla: isaretle',
    toolSelect: 'Sec',
    toolMove: 'Tasi',
    toolResize: 'Boyutla',
    toolColor: 'Renk',
    toolFont: 'Font',
    toolText: 'Metin',
    toolEffect: 'Efekt',
    toolError: 'Hata Isaretle',
    toolAdd: 'Buraya Ekle',
    toolNote: 'Not Birak',
    colorText: 'Yazi',
    colorBg: 'Arka Plan',
    colorBorder: 'Cizgi',
    customColor: 'Ozel Renk',
    fontSize: 'Boyut',
    shadow: 'Golge',
    dragHint: 'Secili elementi surukleyerek tasiyin',
    textHint: 'Elementin uzerine tiklayip metni duzenleyin',
    pendingEdits: 'degisiklik bekliyor',
    clearAll: 'Temizle',
    showEdits: 'Degisiklikleri Goster',
    hideEdits: 'Gizle',
    saveAndSend: "AI'a Gonder",
    sendConfirm: {
      title: 'Degisiklikleri Gonder',
      message: '{{count}} degisiklik AI\'a gonderilecek. Devam etmek istiyor musunuz?',
      cancel: 'Vazgec',
      confirm: 'Gonder',
    },
    editList: 'Degisiklikler',
    removeEdit: 'Geri al',
    errorNotePlaceholder: 'Hata aciklamasi: burada ne yanlis?',
    addNotePlaceholder: 'Buraya ne eklenmeli?',
    annotationPlaceholder: 'Not...',
    fileMap: 'Dosya Haritasi',
    noNavigation: 'Henuz dosya navigasyonu yok',
    startAgent: 'Baslatmak icin agent calistirin',
    mapWillActivate: 'Agent dosya islemleri basladiginda harita canlanir',
    gpsNavigation: 'GPS navigasyon haritasi',
    clickToExpand: 'Genisletmek icin tiklayin',
    thinking: 'Dusunuyor...',
    showOutput: 'Ciktiyi Goster',
    hideOutput: 'Ciktiyi Gizle',
    visits: 'ziyaret',
    devServer: 'Dev Server',
    devServerStarting: 'Dev server baslatiliyor...',
    devServerReady: 'Dev server hazir',
    devServerError: 'Dev server basarilamadi',
    devServerPort: 'Port',
    devServerRestart: 'Yeniden Baslat',
    installing: 'Paketler kuruluyor...',
    modelDescHaiku: 'Hizli, ekonomik',
    modelDescSonnet: 'Dengeli, guclu',
    modelDescOpus: 'Maksimum yetenek',
    detectedTools: 'Algilanan AI Araclari',
    toolNotFound: 'Bu sistemde bulunamadi',
    noSpawnableTools: 'Calistirilebilir AI CLI araci bulunamadi. Claude Code, Aider veya Codex CLI yukleyin.',
    quickUseTailwind: 'Tailwind Kullan',
    quickFollowPatterns: 'Desenleri Takip Et',
    quickAddTypeScript: 'TypeScript Ekle',
    quickResponsive: 'Responsive Yap',
    fixThisFile: 'Bu dosyayi duzelt',
    testThis: 'Bunun icin test yaz',
    refactorThis: 'Bu componenti refactor et',
    improveStyle: 'Stili iyilestir',
    continueCurrent: 'Mevcut goreve devam et',
    switchTask: 'Yeni goreve gec',
    reviewChanges: 'Yapilan degisiklikleri incele',
    spawning: 'Baslatiliyor...',
    injecting: 'Enjekte ediliyor...',

    tempChangesWarning: 'Degisiklikler gecicidir. Kalici yapmak icin AI\'a gonderin.',

    // Prompt History
    promptHistory: {
      title: 'Prompt Gecmisi',
      historyTab: 'Gecmis',
      templatesTab: 'Sablonlar',
      searchPlaceholder: 'Gecmiste ara...',
      noMatchingPrompts: 'Eslesen prompt bulunamadi',
      noHistoryYet: 'Henuz prompt gecmisi yok',
      tryDifferentSearch: 'Farkli bir arama deneyin',
      promptsWillAppear: 'Prompt\'lar agent calistirdiktan sonra burada gorunecek',
      copyToClipboard: 'Panoya kopyala',
      deleteFromHistory: 'Gecmisten sil',
      of: '/',
      prompts: 'prompt',
      clearAll: 'Tumunu Temizle',
      clickToUse: 'Kullanmak icin tikla',
      templateHint: 'Prompt\'unuz olarak kullanmak icin bir sablon secin. Baslatmadan once duzenleyebilirsiniz.',
    },

    // Hizli Baslat Sablonlari
    presets: {
      title: 'Hizli Sablonlar',
      landingPage: 'Landing Page',
      landingPageDesc: 'Hero, ozellikler, fiyatlandirma ve iletisim bolumlu modern sayfa',
      bugFix: 'Hata Duzeltme',
      bugFixDesc: 'Kod tabanini analiz et, hatalari bul ve duzelt',
      fullApp: 'Tam Uygulama',
      fullAppDesc: 'Proje gereksinimlerine gore eksiksiz web uygulamasi olustur',
      apiBackend: 'API Backend',
      apiBackendDesc: 'CRUD endpoint, validasyon ve hata yonetimli REST API',
      uiPolish: 'UI Cilalama',
      uiPolishDesc: 'Stil, animasyon ve responsive tasarim iyilestirmeleri',
      testSuite: 'Test Paketi',
      testSuiteDesc: 'Kapsamli unit ve entegrasyon testleri',
      saveAsCurrent: 'Mevcut prompt\'u sablon olarak kaydet',
      presetName: 'Sablon adi...',
      save: 'Kaydet',
    },

    // Rules
    rules: {
      title: 'Proje Kurallari',
      placeholder: 'Proje kurallarinizi buraya yazin...\n- Her zaman Tailwind kullan\n- TypeScript strict mode\n- Dosya adlari kebab-case',
      active: 'Aktif',
      inactive: 'Devre Disi',
      toggle: 'Kurallari Degistir',
      saved: 'Kaydedildi',
      saving: 'Kaydediliyor...',
      autoSaveHint: 'Yazarken otomatik kaydeder',
      noRules: 'Kural tanimlanmamis',
      rulesWillBePrepended: 'Proje kurallari prompt\'a otomatik eklenir',
    },

    // Memory
    memory: {
      title: 'Proje Hafizasi',
      add: 'Ekle',
      edit: 'Duzenle',
      delete: 'Sil',
      pin: 'Sabitle',
      unpin: 'Sabitlemeyi Kaldir',
      pinned: 'Sabitlenmis',
      category: 'Kategori',
      search: 'Ara...',
      noMemories: 'Henuz hafiza yok',
      addNew: 'Yeni Hafiza Ekle',
      categoryArchitecture: 'Mimari',
      categoryConventions: 'Kurallar',
      categoryBugs: 'Bilinen Hatalar',
      categoryPatterns: 'Desenler',
      categoryGeneral: 'Genel',
      saveMemory: 'Kaydet',
      cancelMemory: 'Iptal',
      pinnedWillBeIncluded: 'sabitlenmis hafiza context\'e dahil edilecek',
      titlePlaceholder: 'Baslik...',
      contentPlaceholder: 'Icerik...',
    },

    // Session History
    history: {
      title: 'Oturum Gecmisi',
      noSessions: 'Henuz oturum yok',
      rerun: 'Tekrar Calistir',
      viewDetails: 'Detaylar',
      copyPrompt: 'Prompt Kopyala',
      spawnWithSame: 'Ayni Yapilandirma ile Baslat',
      filesCount: 'dosya',
      tokensUsed: 'token',
      duration: 'Sure',
      ago: 'once',
      completed: 'Tamamlandi',
      crashed: 'Coktu',
      empty: 'Bos',
    },

    // Context Menu
    contextMenu: {
      editText: 'Metni Duzenle',
      copySelector: 'Selektoru Kopyala',
      changeColor: 'Renk Degistir',
      colorText: 'Yazi Rengi',
      colorBg: 'Arka Plan',
      colorBorder: 'Cizgi Rengi',
      fontSize: 'Font Boyutu',
      addEffect: 'Efekt Ekle',
      shadowNone: 'Yok',
      shadowLight: 'Hafif',
      shadowMedium: 'Orta',
      shadowStrong: 'Guclu',
      shadowEmboss: 'Kabartma',
      resize: 'Genislet/Daralt',
      markError: 'Hata Isaretle',
      addHere: 'Buraya Ekle',
      addNote: 'Not Birak',
      addPrompt: 'Prompt Ekle',
      showPins: 'Tum Pinleri Goster',
      hidePins: 'Pinleri Gizle',
      addRefImage: 'Referans Gorsel Ekle',
      clearAll: 'Tum Duzenlemeleri Temizle',
      deletePin: 'Sil',
      editPin: 'Duzenle',
    },

    // Prompt Pins
    promptPin: {
      title: 'Prompt Pin',
      placeholder: 'Detayli talimatinizi yazin...',
      nearElement: 'Yakin element',
      coordinate: 'Koordinat',
      save: 'Kaydet',
      cancel: 'Iptal',
      ctrlEnter: 'Ctrl+Enter ile kaydet',
      count: 'pin',
      editTitle: 'Pin Duzenle',
    },

    // Reference Image
    refImage: {
      title: 'Referans Gorsel',
      opacity: 'Opakllik',
      remove: 'Kaldir',
      show: 'Goster',
      hide: 'Gizle',
    },

    // Phase Execution
    phase: {
      title: 'Faz Takibi',
      phase: 'Faz',
      approve: 'Onayla',
      reject: 'Reddet',
      pending: 'Bekliyor',
      running: 'Calisiyor',
      awaitingApproval: 'Onay Bekliyor',
      approved: 'Onaylandi',
      rejected: 'Reddedildi',
      completed: 'Tamamlandi',
      failed: 'Basarisiz',
      styleChanges: 'Stil Degisiklikleri',
      contentAdditions: 'Icerik Eklemeleri',
      errorFixes: 'Hata Duzeltmeleri',
      acceptCriteria: 'Kabul Kriteri',
    },

    // GPS Controls
    // Layout
    layout: {
      gpsFocus: 'GPS Odak',
      editorFocus: 'Editor Odak',
      balanced: 'Dengeli',
      showLeft: 'Sol Paneli Goster',
      hideLeft: 'Sol Paneli Gizle',
      showRight: 'Sag Paneli Goster',
      hideRight: 'Sag Paneli Gizle',
      doubleClickReset: 'Sifirlamak icin cift tikla',
    },

    // Toast Bildirimleri
    toast: {
      agentStarted: 'Agent baslatildi',
      agentCompleted: 'Agent basariyla tamamlandi',
      agentCrashed: 'Agent coktu',
      agentPaused: 'Agent duraklatildi',
      agentResumed: 'Agent devam ediyor',
      injectionApplied: 'Enjeksiyon uygulandi',
    },

    // Timeline
    timeline: {
      title: 'Aktivite Zaman Cizelgesi',
      empty: 'Henuz aktivite yok',
    },

    // Oturum Disa Aktarim
    sessionExport: {
      title: 'Oturum Disa Aktarimi',
      downloadJson: 'JSON Rapor Indir',
      copySummary: 'Ozeti Kopyala',
      copy: 'Kopyala',
      copied: 'Kopyalandi!',
      noSession: 'Aktif oturum yok',
    },

    // Window Manager
    windowManager: {
      panelMenu: 'Panel Menu',
      resetLayout: 'Duzeni Sifirla',
      presetIde: 'IDE Stili',
      presetGps: 'GPS Odak',
      presetMonitor: 'Monitor',
      minimize: 'Kucult',
      maximize: 'Tam Ekran',
      restore: 'Geri Yukle',
      close: 'Kapat',
      bringToFront: 'One Getir',
      panelVisualEditor: 'Gorsel Editor',
      panelGpsNavigator: 'GPS Navigator',
      panelAgentTracker: 'Agent Takip',
      panelPhaseViewer: 'Faz Gorunumu',
      panelPromptInjector: 'Prompt Enjeksiyon',
      panelActivityTimeline: 'Aktivite Zaman Cizelgesi',
      panelAgentOutput: 'Agent Ciktisi',
      panelRulesEditor: 'Kural Editoru',
      panelMemoryManager: 'Hafiza Yoneticisi',
      panelSessionHistory: 'Oturum Gecmisi',
    },

    // Klavye Kisayollari
    shortcuts: {
      title: 'Klavye Kisayollari',
      gpsFullscreen: 'Ctrl+Shift+G: GPS Tam Ekran',
      editorFullscreen: 'Ctrl+Shift+E: Editor Tam Ekran',
      promptFocus: 'Ctrl+Shift+P: Prompt Odakla',
      togglePause: 'Bosluk: Duraklat/Devam',
      toggleBreakpoint: 'Ctrl+Shift+B: Breakpoint Degistir',
      toggleOutput: 'Ctrl+Shift+O: Ciktiyi Ac/Kapat',
      escape: 'Escape: Tam Ekrandan Cik',
    },

    // Editor Toolbar
    editorToolbar: {
      undo: 'Geri Al (Ctrl+Z)',
      redo: 'Yinele (Ctrl+Y)',
      domTree: 'DOM Agaci',
      diffView: 'Fark Gorunumu',
    },

    // GPS auto-follow
    gps: {
      autoFollow: 'Otomatik Takip',
      pauseAgent: 'Duraklat',
      stopAgent: 'Durdur',
      sendPrompt: 'Prompt Gonder',
      switchFile: 'Dosya Degistir',
      viewOutput: 'Mevcut Ciktiyi Gor',
      fileInfo: 'Dosya Bilgisi',
      duration: 'Sure',
      lastToolCalls: 'Son Tool Cagrilari',
      doInFile: 'Bu dosyada yap',
      viewContent: 'Icerigi Gor',
      viewHistory: 'Gecmisi Gor',
      compact: 'Kompakt',
      expanded: 'Genisletilmis',
      lineRange: 'Satir',
      toolName: 'Arac',
      searchFiles: 'Dosya ara...',
      heatmap: 'Isi Haritasi',
      panMode: 'Tasima Modu (El Araci)',
      minimap: 'Mini Harita',
      zoomIn: 'Yakinlastir',
      zoomOut: 'Uzaklastir',
      resetView: 'Gorunumu Sifirla',
      stats: 'Istatistikler',
      timeline: 'Zaman Cizelgesi',
      live: 'CANLI',
      replay: 'Tekrar Oynat',
      redirect: 'Agent\'i Buraya Yonlendir',
      setBreakpoint: 'Breakpoint Koy',
      setBreakpointDesc: 'Agent bu dosyaya gelince duraklat',
      removeBreakpoint: 'Breakpoint Kaldir',
      removeBreakpointDesc: 'Dosyadaki durdurma noktasini kaldir',
      improveFileDesc: 'Agent\'tan bu dosyayi iyilestirmesini iste',
      copyPath: 'Yolu Kopyala',
      previewFile: 'Dosya Onizleme',
      activity: 'Aktivite',
      noPreview: 'Onizleme mevcut degil',
      topFiles: 'En Cok Ziyaret',
      fullscreen: 'Tam Ekran',
      exitFullscreen: 'Tam Ekrandan Cik',
      visitCount: 'ziyaret',
      avgPerFile: 'Ort/dosya',
      filesVisited: 'Ziyaret Edilen',
      totalVisits: 'Toplam Ziyaret',
      breakpointHit: 'Breakpoint Tetiklendi',
      injectionQueued: 'Enjeksiyon Kuyrukta',
      conflictWarning: 'Cakisma Uyarisi',
      agentRedirected: 'Agent Yonlendirildi',
    },

    // Chat
    chat: {
      title: 'AI Sohbet',
      messages: 'mesaj',
      placeholder: 'Mesaj yaz...',
      empty: 'Henuz mesaj yok. Agent calistirinca yanitlar burada gorunecek.',
      attachFile: 'Dosya Ekle',
      send: 'Gonder',
    },

    // File Upload
    upload: {
      title: 'Dosya Yukleme',
      dragDrop: 'Dosyalari surukle & birak',
      maxSize: 'Maks 10MB',
      uploading: 'Yukleniyor...',
    },

    status: {
      idle: 'BOSTA',
      spawning: 'BASLATILIYOR',
      running: 'CALISIYOR',
      paused: 'DURAKLATILDI',
      injecting: 'ENJEKTE EDILIYOR',
      stopping: 'DURDURULUYOR',
      crashed: 'COKTU',
      completed: 'TAMAMLANDI',
    },
    activity: {
      thinking: 'Dusunuyor',
      reading: 'Okuyor',
      writing: 'Yaziyor',
      searching: 'Ariyor',
      executing: 'Calistiriyor',
      waiting: 'Bekliyor',
      idle: 'Bosta',
    },
  },

  // Login
  login: {
    title: 'VOLTRON',
    subtitle: 'AI Operasyon Kontrol Merkezi',
    username: 'Kullanici Adi',
    password: 'Sifre',
    newPassword: 'Yeni Sifre',
    confirmPassword: 'Sifre Tekrar',
    signIn: 'Giris Yap',
    invalidCredentials: 'Kullanici adi ve sifre bos birakilamaz.',
    signOut: 'Cikis Yap',
    welcomeBack: 'Tekrar Hosgeldiniz',
    firstTimeSetup: 'Ilk Kurulum',
    createAdminDesc: 'Sisteme erisim icin bir admin hesabi olusturun.',
    createAdmin: 'Admin Hesabi Olustur',
    usernameMin: 'Kullanici adi en az 3 karakter olmalidir.',
    passwordMin: 'Sifre en az 6 karakter olmalidir.',
    passwordMismatch: 'Sifreler eslesmiyor.',
    passwordRequirements: 'Kullanici adi min. 3, sifre min. 6 karakter.',
  },

  // Not Found
  notFound: {
    message: 'Aradiginiz sayfa bulunamadi.',
    backToDashboard: 'Dashboard\'a Don',
  },

  // Language
  language: {
    tr: 'TR',
    en: 'EN',
  },

  // Komut Paleti
  commandPalette: {
    placeholder: 'Komut yazin...',
    noResults: 'Eslesen komut bulunamadi',
    panels: 'Paneller',
    layout: 'Yerlesim',
    agent: 'Agent',
    navigation: 'Navigasyon',
    show: 'Goster',
    hide: 'Gizle',
    maximize: 'Tam Ekran',
    layoutIDE: 'IDE Yerlesimi',
    layoutGPS: 'GPS Odakli Yerlesim',
    layoutMonitor: 'Monitor Yerlesimi',
    layoutMinimal: 'Minimal Yerlesim',
    layoutDevelopment: 'Gelistirme Yerlesimi',
    layoutReset: 'Yerlesimi Sifirla',
    recent: 'Son Kullanilanlar',
    injectFix: 'Inject: Mevcut dosyayi duzelt',
    injectExplain: 'Inject: Bu kodu acikla',
    showShortcuts: 'Klavye Kisayollarini Goster',
    openSettings: 'Ayarlari Ac',
    switchLanguage: 'Dil Degistir',
    navigate: 'Gezin',
    execute: 'Calistir',
    close: 'Kapat',
  },

  // Klavye Kisayollari
  shortcuts: {
    title: 'Klavye Kisayollari',
    global: 'Genel',
    agent: 'Agent',
    panels: 'Paneller',
    gps: 'GPS Navigasyon',
    commandPalette: 'Komut Paleti',
    showShortcuts: 'Kisayollari Goster',
    emergencyStop: 'Acil Durdurma',
    closeModal: 'Modal Kapat / Cikis',
    pauseResume: 'Duraklat / Devam Et',
    focusPrompt: 'Prompt Alanina Odaklan',
    toggleBreakpoint: 'Kesme Noktasi Degistir',
    toggleOutput: 'Cikti Panelini Degistir',
    sendPrompt: 'Prompt Gonder',
    gpsFullscreen: 'GPS Tam Ekran',
    editorFullscreen: 'Editor Tam Ekran',
    togglePanelMenu: 'Panel Menusunu Degistir',
    cyclePanels: 'Paneller Arasi Gezin',
    searchFiles: 'Dosya Ara',
    zoomInOut: 'Yakinlastir / Uzaklastir',
    panAlways: 'Tasima (her zaman)',
    panMode: 'Tasima modu surukle',
    scroll: 'Kaydirma',
    middleClick: 'Orta Tik',
    handTool: 'El Araci',
    footer: 'Bu diyalogu gostermek icin ? tusuna basin',
  },

  // Hosgeldiniz Turu
  tour: {
    title: 'Voltron\'a Hosgeldiniz',
    subtitle: 'Temel ozellikleri kesfetmek icin hizli bir tur yapalim.',
    skipTour: 'Turu Atla',
    previous: 'Onceki',
    next: 'Sonraki',
    finish: 'Tamamla',
    stepOf: '{current} / {total}',
    completedTitle: 'Tur Tamamlandi!',
    completedMessage: 'Artik Voltron\'u kullanmaya hazirsiniz. Iyi calisma!',
    close: 'Basla',
    step1Title: 'Interaktif Demo',
    step1Desc: 'Kurulum gerekmez! Feed sekmesinde "Try Demo" butonuna tiklayarak 14 kurallik risk motorunun dosya islemlerini gercek zamanli siniflandirmasini izleyin. Sifir AI token tuketir.',
    step2Title: 'Hizli Prompt Bar',
    step2Desc: 'Alttaki prompt cubugu ile hizlica agent baslatabilir veya oturum ortasinda talimat enjekte edebilirsiniz. Ctrl+Enter ile gonderin. Hizli aksiyon cip\'leri yaygin gorevler icin tek tik saglar.',
    step3Title: 'Agent Calisma Alani',
    step3Desc: 'Ana calisma alaniniz. AI agent\'i baslatir, izler ve yonetirsiniz. Prompt enjeksiyonu, faz takibi, GPS navigasyonu ve cikti panelleri Agent sekmesinden erisilebilinir.',
    step4Title: 'Koruma Bolgeleri',
    step4Desc: 'Kritik dosyalari DO_NOT_TOUCH olarak isaretleyerek tehlikeli degisiklikleri engelleyin. Risk motoru koruma bolgelerini ihlal eden islemleri otomatik isaretler.',
    step5Title: 'GPS Navigasyon Haritasi',
    step5Desc: 'Agent\'in dosya sisteminde nerede calistigini gercek zamanli gorsellestirir. Isi haritasi, zoom, pan ve breakpoint ozellikleri iceren interaktif harita.',
    step6Title: 'Gorsel Editor ve Referans Tasarim',
    step6Desc: 'Canli onizleme ile dogrudan UI uzerinde duzenleme yapin. Bir referans tasarim ekran goruntusu yukleyin ve AI\'nin benzer bilesenler uretmesini saglayin. Sag tik menusunden 30+ secenek.',
    step7Title: 'Klavye Kisayollari',
    step7Desc: 'Ctrl+K ile komut paletini acin, ? ile tum kisayollari gorun. Bosluk tusuna basarak agent\'i hizla duraklatip devam ettirebilirsiniz.',
  },

  // Ayarlar
  settings: {
    title: 'Ayarlar',
    language: 'Dil',
    defaultModel: 'Varsayilan AI Modeli',
    defaultLayout: 'Varsayilan Yerlesim',
    notifications: 'Bildirimler',
    turkish: 'Turkce',
    modelFast: 'Hizli',
    modelBalanced: 'Dengeli',
    modelPowerful: 'Guclu',
    changePassword: 'Sifre Degistir',
    currentPassword: 'Mevcut Sifre',
    updatePassword: 'Sifreyi Guncelle',
    passwordChanged: 'Sifre basariyla degistirildi.',
    pwFieldsRequired: 'Mevcut ve yeni sifre alanlari zorunludur.',
  },

  // Smart Setup
  smartSetup: {
    title: 'Smart Setup',
    subtitle: 'AI destekli proje yapilandirmasi — otonom kesfet, otomatik kur.',
    startDiscovery: 'Kesfet',
    applySelected: 'Secilenleri Kur',
    analyzing: 'Proje analiz ediliyor...',
    discovering: 'GitHub\'da araniyor...',
    evaluating: 'Degerlendirilyor...',
    ready: 'Hazir — repo secin ve kurun',
    applying: 'Kurulum yapiliyor...',
    completed: 'Kurulum tamamlandi',
    failed: 'Kurulum basarisiz',
    profileTitle: 'Proje Profili',
    resultsTitle: 'Kesfedilen Repolar',
    relevance: 'Uygunluk',
    recommended: 'Onerilen',
    noResults: 'Sonuc bulunamadi',
    existingSetup: 'Mevcut Kurulum',
    missingSetup: 'Eksik',
    useGithub: 'GitHub\'da yararli repolar ara',
    skipGithubHint: 'Sadece proje profili analiz edilecek, GitHub araması yapilmayacak.',
    profileOnly: 'Proje profili analiz edildi. GitHub araması atlandı.',
  },

  // Mobil UI
  mobile: {
    more: 'Daha Fazla',
    menu: 'Menu',
    showPanel: 'Paneli Goster',
    hidePanel: 'Paneli Gizle',
    feed: 'Akis',
    github: 'GitHub',
    agent: 'Agent',
    setup: 'Setup',
    snapshots: 'Snapshots',
    behavior: 'Davranis',
    prompts: 'Promptlar',
    monitoring: 'Izleme Paneli',
    theme: 'Tema',
    toggleSidebar: 'Kenar cubugunu ac/kapat',
    bottomNav: 'Alt navigasyon',
  },

  // Dashboard Mode
  dashboardMode: {
    essential: 'Temel',
    active: 'Aktif',
    allTools: 'Tum Araclar',
  },

  // GPS Timeline
  gpsTimeline: {
    start: 'Baslat',
    pause: 'Duraklat',
    play: 'Oynat',
    skipToLive: 'Canliya atla',
    live: 'CANLI',
  },

  // Getting Started
  gettingStarted: {
    title: 'Baslarken',
    dismiss: 'Kapat',
    tryDemo: 'Interaktif Demoyu Dene',
    tryDemoDesc: 'Risk motorunun dosya islemlerini nasil siniflandirdigini gercek zamanli gorun.',
    startDemo: 'Demo Baslat',
    spawnAgent: 'Ilk Agent\'ini Baslat',
    spawnAgentDesc: 'Claude\'a bir gorev ver ve Voltron\'un her dosya degisikligini izlemesini izle.',
    spawnAgentBtn: 'Agent Baslat',
    setupZones: 'Koruma Bolgeleri Olustur',
    setupZonesDesc: 'Kritik dosyalari DO_NOT_TOUCH olarak isaretleyerek tehlikeli degisiklikleri engelleyin.',
    customize: 'Kurulumunu Ozellestir',
    customizeDesc: 'Varsayilan model, dil ve bildirim tercihlerini ayarla.',
    openSettings: 'Ayarlari Ac',
  },

  // Live Preview
  livePreview: {
    loadFailed: 'Preview yuklenemedi',
    unsupportedType: 'Bu dosya turu onizlenemez',
    useCodeView: '{ext} dosyalari icin kod gorunumunu kullanin',
    rendering: 'Render ediliyor...',
    retry: 'Yeniden dene',
    refresh: 'Yenile',
  },

  // GPS File Preview
  gpsFilePreview: {
    changes: 'degisiklik',
    files: 'dosya',
    clearFileTooltip: 'Bu dosyanin degisikliklerini temizle',
    clearAll: 'Tumunu Temizle',
    sendAllToAI: 'Tumunu AI\'ye Gonder',
    editTextTitle: 'Metin Duzenle',
    newContentLabel: 'Yeni icerik',
    newContentPlaceholder: 'Yeni metin giriniz...',
    ctrlEnterHint: 'Ctrl+Enter ile hizlica uygulayabilirsiniz',
    cancel: 'Iptal',
    apply: 'Uygula',
    confirmCancel: 'Vazgec',
    confirmOk: 'Onayla',
    changesSent: '{count} degisiklik AI\'ye gonderildi',
    historyCleared: 'Degisiklik gecmisi temizlendi',
    askAIPrompt: 'Bu element hakkinda yardim istiyorum:\\n{elementInfo}\\nSelector: {selector}\\nDosya: {filePath}',
    styleApplied: 'Stil uygulandı',
    textUpdated: 'Metin guncellendi',
    elementDeleted: 'Element silindi',
    elementDuplicated: 'Element kopyalandi',
    visibilityToggled: 'Gorunurluk degistirildi',
    visits: 'ziyaret',
    live: 'Canli',
    historyTooltip: 'Aktivite gecmisi',
    minimizeTooltip: 'Kucult',
    maximizeTooltip: 'Tam ekran',
    closeTooltip: 'Kapat (Esc)',
    activity: 'Aktivite',
    designModeHint: 'Sag tikla: Tasarim modu',
    changesCount: '{count} degisiklik',
    totalChanges: 'toplam {total} ({fileCount} dosya)',
    clearFileChanges: 'Bu dosyanin degisikliklerini temizle',
    sendAllToAITooltip: 'Tum dosyalardaki degisiklikleri AI\'ye gonder',
    sendToAI: 'AI\'ye Gonder',
    escCloseHint: 'Esc: Kapat',
    deleteElementTitle: 'Elementi Sil',
    deleteElementMessage: 'Bu element DOM\'dan tamamen kaldirilacak. Bu islem geri alinamaz. Devam etmek istiyor musunuz?',
  },

  // Durum Cubugu
  statusBar: {
    events: 'olay',
    noEvents: 'Olay yok',
    emergencyStop: 'Ctrl+Shift+S: Acil Durdurma',
    connected: 'WebSocket Bagli',
    disconnected: 'WebSocket Bagli Degil',
    eventRate: 'Dakika basina olay',
    uptime: 'Sunucu Calisma Suresi',
    commandPalette: 'Komutlar',
  },
  // Design Context Menu
  designMenu: {
    content: 'Icerik',
    contentDesc: 'Metin, font, hizalama',
    appearance: 'Gorunum',
    appearanceDesc: 'Renk, opaklık, cerceve',
    layout: 'Yerlesim',
    layoutDesc: 'Flex, grid, bosluk',
    effects: 'Efektler',
    effectsDesc: 'Golge, blur, animasyon',
    structure: 'Yapi',
    structureDesc: 'Kopyala, sil, sifirla',
    red: 'Kirmizi',
    orange: 'Turuncu',
    yellow: 'Sari',
    green: 'Yesil',
    blue: 'Mavi',
    purple: 'Mor',
    pink: 'Pembe',
    neutral: 'Notr',
    sunset: 'Gunes Batimi',
    ocean: 'Okyanus',
    forest: 'Orman',
    night: 'Gece',
    gold: 'Altin',
    ice: 'Buz',
    fire: 'Ates',
    aurora: 'Aurora',
    carbon: 'Karbon',
    none: 'Yok',
    light: 'Hafif',
    medium: 'Orta',
    strong: 'Guclu',
    up: 'Yukari',
    blueGlow: 'Mavi Glow',
    greenGlow: 'Yesil Glow',
    purpleGlow: 'Mor Glow',
    redGlow: 'Kirmizi Glow',
    editText: 'Metni Duzenle',
    editTextDesc: 'Secili elementin ic metnini premium editor ile degistir.',
    boldLabel: 'Kalin Yazi',
    boldDesc: 'Font kalinligini bold/normal arasinda toggle et.',
    italicLabel: 'Italik',
    italicDesc: 'Yaziyi italik/normal arasinda toggle et.',
    underlineLabel: 'Alti Cizili',
    underlineDesc: 'Yazi altina cizgi ekle veya kaldir.',
    fontIncrease: 'Yazi Boyutu +2px',
    fontIncreaseDesc: 'Mevcut: {size} → artir.',
    fontDecrease: 'Yazi Boyutu -2px',
    fontDecreaseDesc: 'Mevcut: {size} → azalt.',
    alignLeft: 'Sola Hizala',
    alignCenter: 'Ortala',
    alignRight: 'Saga Hizala',
    textColor: 'Yazi Rengi',
    textColorDesc: 'Mevcut: {color}. Genis renk paletinden sec.',
    bgColor: 'Arka Plan Rengi',
    bgColorDesc: 'Mevcut: {color}. Renk sec.',
    borderColor: 'Cerceve Rengi',
    opacityUp: 'Opaklik +10%',
    opacityUpDesc: 'Elementin gorununurluk yogunlugunu artir.',
    opacityDown: 'Opaklik -10%',
    opacityDownDesc: 'Elementi daha seffaf yap. Katmanli tasarim icin.',
    borderRadiusAdd: 'Koseleri Yuvarla +4px',
    borderRadiusAddDesc: 'Mevcut: {radius}. Daha yumusak koseler.',
    borderRadiusRemove: 'Koseleri Duzlestir',
    borderAdd: 'Cerceve Ekle',
    border2px: 'Kalin Cerceve',
    borderRemove: 'Cerceveyi Kaldir',
    displayFlexDesc: 'Cocuk elementleri yan yana diz. display:flex.',
    displayGridDesc: 'CSS Grid sistemi aktif et. display:grid.',
    displayBlock: 'Blok',
    displayBlockDesc: 'display:block — her element yeni satirda.',
    displayInlineFlex: 'Inline Flex',
    displayNone: 'Gizle',
    displayNoneDesc: 'display:none ile elementi tamamen gizle.',
    centerFlex: 'Flex ile Ortala',
    flexColumn: 'Flex Dikey',
    flexColumnDesc: 'flex-direction: column — elementleri alt alta diz.',
    flexBetween: 'Flex Space-Between',
    flexBetweenDesc: 'Elementleri esit aralikla diz.',
    gapAdd: 'Gap +8px',
    gapAddDesc: 'Flex/Grid elemanlar arasi bosluk artir.',
    paddingAdd: 'Padding +8px',
    paddingAddDesc: 'Mevcut: {padding}. Ic bosluk artir.',
    paddingRemove: 'Padding -8px',
    marginAdd: 'Margin +8px',
    marginAddDesc: 'Mevcut: {margin}. Dis bosluk artir.',
    width100: 'Tam Genislik',
    width100Desc: 'width: 100% — tum genisligi kapla.',
    positionRelative: 'Position: Relative',
    positionRelativeDesc: 'Akis icerisinde kaydirmaya izin verir.',
    positionAbsolute: 'Position: Absolute',
    positionAbsoluteDesc: 'Parent elementa gore serbest konumlandirma.',
    overflowHidden: 'Overflow Hidden',
    overflowHiddenDesc: 'Tasmis icerigi gizle.',
    shadowPresets: 'Golge Preset\'leri',
    shadowPresetsDesc: '12 hazir golge efekti. Glow, neon, premium...',
    animationPresets: 'Animasyon Preset\'leri',
    animationPresetsDesc: 'Fade, slide, bounce, pulse, spin...',
    blurAdd: 'Bulaniklastir',
    blurAddDesc: 'filter: blur(4px) — arka plan icin glassmorphism.',
    blurRemove: 'Bulanikligi Kaldir',
    blurRemoveDesc: 'filter: none — netligi geri getir.',
    backdropBlur: 'Backdrop Blur',
    backdropBlurDesc: 'Arka plani bulaniklastir. Cam efekti.',
    transitionSmooth: 'Gecis: Smooth (0.3s)',
    transitionSmoothDesc: 'transition: all 0.3s ease — yumusak gecis.',
    transitionSpring: 'Gecis: Spring (0.5s)',
    transitionSpringDesc: 'Yay efektli gecis animasyonu.',
    scaleUp: 'Buyut (%110)',
    scaleUpDesc: 'transform: scale(1.1) — elementi buyut.',
    rotate5: 'Dondur 5 derece',
    rotate5Desc: 'transform: rotate(5deg) — hafif yana yatir.',
    transformReset: 'Transform Sifirla',
    transformResetDesc: 'transform: none — normal boyut ve pozisyona dondur.',
    gradientPresets: 'Gradient Preset\'leri',
    gradientPresetsDesc: '10 hazir gradient. Gunes batimi, okyanus, neon...',
    glassmorphism: 'Glassmorphism',
    glassmorphismDesc: 'Cam efekti: seffaf bg + backdrop-blur + ince border.',
    glassDark: 'Glass Dark',
    glassDarkDesc: 'Koyu glassmorphism: karanlik seffaf cam efekti.',
    neumorphism: 'Neumorphism',
    neumorphismDesc: 'Kabartma efekti: ic ve dis golge kombinasyonu.',
    neonBorder: 'Neon Border',
    neonBorderDesc: 'Isildayan neon cerceve efekti.',
    neonText: 'Neon Text',
    neonTextDesc: 'Yaziyi isildayan neon efekti ile goster.',
    frostedCard: 'Frosted Card',
    frostedCardDesc: 'Premium kart stili: glassmorphism + golge + radius.',
    hoverLift: 'Hover Lift Efekti',
    hoverLiftDesc: 'Hover\'da yukselme: translateY + shadow artisi.',
    duplicate: 'Kopyala',
    duplicateDesc: 'Elementi birebir kopyalayip hemen sonrasina yerlestir.',
    toggleVisibility: 'Gorunurlugu Toggle',
    toggleVisibilityDesc: 'Elementi goster/gizle (display none ↔ block).',
    deleteElement: 'Elementi Sil',
    deleteElementDesc: 'DOM\'dan tamamen kaldir. Onay istenir.',
    resetStyles: 'Tum Stilleri Sifirla',
    resetStylesDesc: 'Bu elemente yapilan tum CSS degisikliklerini geri al.',
    askAI: 'AI\'ya Sor',
    askAIDesc: 'Bu element hakkinda AI\'ya soru sor veya degisiklik iste.',
    undoTitle: 'Geri Al (Ctrl+Z)',
    undoLabel: 'Geri Al',
    textColorLabel: 'Yazi Rengi',
    bgColorLabel: 'Arka Plan',
    borderColorLabel: 'Cerceve Rengi',
    selectedColor: 'Secili renk',
    applyColor: 'Rengi Uygula',
    gradientPanelTitle: 'Gradient Preset\'leri',
    customGradient: 'Ozel Gradient (CSS)',
    shadowPanelTitle: 'Golge Preset\'leri',
    customShadow: 'Ozel Shadow (CSS)',
    animationPanelTitle: 'Animasyon Preset\'leri',
    transitionLabel: 'Gecis (Transition)',
    fast: 'Hizli',
  },

  // Demo
  demo: {
    phaseProjectSetup: 'Proje Kurulumu',
    phaseBuilding: 'Kaynak Derleme',
    phaseConfigChanges: 'Yapilandirma Degisiklikleri',
    phaseCritical: '.env KRITIK',
    phaseCascadeAttack: 'Kaskad Saldiri',
    running: 'Demo Calisiyor',
    stop: 'Durdur',
    starting: 'Baslatiliyor...',
    tryDemo: 'Demo Dene',
    inProgress: 'Demo Devam Ediyor',
    inProgressDesc: 'Risk motorunun dosya islemlerini gercek zamanli analiz etmesini izleyin. 5 tirmanan fazda olaylar akisi — guvenli duzenlemelerden kritik .env ihlaline.',
    stopDemo: 'Demoyu Durdur',
    seeInAction: 'Voltron\'u Aksiyonda Gorun',
    seeInActionDesc1: '14 kurallik risk motorunun dosya islemlerini gercek zamanli siniflandirmasini izleyin. Claude CLI gerekmez — sentetik olaylar tam koruma hattini gosterir.',
    seeInActionDesc2: '5 faz: guvenli kurulum, kaynak derleme, yapilandirma degisiklikleri, kritik .env erisimi ve devre kesiciyi tetikleyen kaskad saldiri.',
    startingDemo: 'Demo Baslatiliyor...',
    tryInteractiveDemo: 'Interaktif Demoyu Dene',
    zeroTokens: 'Sifir token, sifir AI cagrisi — tamamen sentetik olaylar',
  },

  // Reference Design Upload
  referenceDesign: {
    title: 'Referans Tasarim',
    uploading: 'Yukleniyor...',
    uploadTitle: 'Referans Tasarim Yukle',
    uploadDesc: 'Ekran goruntusu surukleyin veya tiklayarak secin — AI benzer UI uretecek',
    instructionPlaceholder: "Istege bagli: ozel talimatlar (orn. 'koyu tema kullan', 'animasyon ekle', 'responsive yap')...",
    generateBtn: 'Benzer UI Uret',
    altText: 'Referans tasarim',
  },

  // Editor panels
  editorPanels: {
    domTree: 'DOM Agaci',
    noDOMData: 'DOM verisi yok',
    visualDiff: 'Gorsel Fark ({count} degisiklik)',
  },
} as const;

/** Deeply maps every leaf value of T to `string` */
type DeepStringify<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringify<T[K]>;
};

export type TranslationKeys = DeepStringify<typeof tr>;
